import { html, ref, slotted, when } from "@microsoft/fast-element";
/**
 * The template for the {@link @fabric-msft/fabric-web#Popover} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure and bindings for the `Popover` component.
 * It includes slots for `popover-trigger` and `popover-content`, and conditionally
 * renders a beak element when the `beak` property is true and the `Popover` is open.
 *
 * @param {any} options - Additional options that customize the template.
 *
 * @slot popover-trigger - The trigger element that opens the popover.
 * @slot popover-content - The content to display inside the popover.
 *
 * @csspart popover - The main popover element.
 * @csspart beak - The beak element of the popover.
 * @csspart beak-shadow - The shadow of the beak element.
 *
 * @returns {ElementViewTemplate<Popover>} The template for the `Popover` component.
 */
function popoverTemplate() {
    return html `
    <slot name="start"></slot>
    <div class="popover-container" role="dialog">
      <slot name="popover-trigger" ${slotted("anchorReferences")}></slot>
      <div
        role="${(x) => x.popoverRole}"
        aria-label="${(x) => x.ariaLabel}"
        class="popover"
        part="popover"
        id="${(x) => x.targetId}"
        ${ref("popoverReference")}
      >
        <slot name="popover-content" part="popover-content"></slot>
        ${when((x) => x.beak, html `
            <div part="beak" class="beak"></div>
          `)}
      </div>
      ${when((x) => x.beak, html `
          <div part="beak-shadow" class="beak-shadow"></div>
        `)}
    </div>
    <slot name="end"></slot>
  `;
}
export const template = popoverTemplate();
//# sourceMappingURL=popover.template.js.map